<template>
  <div class="jobDetail breadcrumbs-absolute aboutUs siteMapPage Disclaimer" :class="{'aboutUsPC':$store.state.innerWidth>768}">
    <div class="header jobPosingSearch row flexHeader flexHeaderJia200">
    <Breadcrumbs></Breadcrumbs>
        <div class="warp-mask"></div>
        <div class="job-containers-center col-sm-10 col-md-8 padLeft-0 padRight-0">
            <h1 class="Bold" :class="{'font-size-60':$store.state.innerWidth>768}"> {{$t('message.siteMap')}}</h1>
        </div>
    </div>
    <div class="opp-contain row">
      <div class="siteMap-pc marin-b-100">
        <div class="descriptionPC-right col-sm-12 col-md-12 padLeft-0 padRight-0" >
            <div class="contentGroup padding-b-50">
               <div class="page1" >
                <div class="jobFunctionList">
                    <div class="jobFunction"  :class="active" v-on:click="select('Home','home')">
                        <div class="jobFunction-contian">
                            <span class="jobGroup mainColor jobGroupText SemiBold">
                                <a href="javascript:;" style="color: inherit; text-decoration: none">{{ $t(("message.Home")) }}</a>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="jobFunctionList">
                    <div class="jobFunction"  :class="active" v-on:click="select('Eight Centres','eightCentres')">
                        <div class="jobFunction-contian">
                            <span class="jobGroup mainColor jobGroupText SemiBold">
                                <a href="javascript:;" style="color: inherit; text-decoration: none">{{ $t(("message.Eight Centres")) }}</a>
                            </span>
                        </div>
                    </div>
                </div>
                <!-- <div class="jobFunctionList">
                    <div class="jobFunction"  :class="active" v-on:click="select('Online Magazine','magazine')">
                        <div class="jobFunction-contian">
                            <span class="jobGroup mainColor jobGroupText SemiBold">
                                <a href="javascript:;" style="color: inherit; text-decoration: none">{{ $t(("message.Online Magazine")) }}</a>
                            </span>
                        </div>
                    </div>
                </div> -->
                <div class="jobFunctionList">
                    <div class="jobFunction"  :class="active" v-on:click="select('Browse Occupations','browseOccupations')">
                        <div class="jobFunction-contian">
                            <span class="jobGroup mainColor jobGroupText SemiBold">
                                <a href="javascript:;" style="color: inherit; text-decoration: none">{{ $t(("message.Browse Occupations")) }}</a>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="jobFunctionList">
                    <div class="jobFunction"  :class="active" v-on:click="select('Find A Job Opportunity','findAnOpportunity')">
                        <div class="jobFunction-contian">
                            <span class="jobGroup mainColor jobGroupText SemiBold">
                                <a href="javascript:;" style="color: inherit; text-decoration: none">{{ $t(("message.Find a Job Opportunity")) }}</a>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="jobFunctionList">
                    <div class="jobFunction"  :class="active" v-on:click="select('Browse Courses','browseCourses')">
                        <div class="jobFunction-contian">
                            <span class="jobGroup mainColor jobGroupText SemiBold">
                                <a href="javascript:;" style="color: inherit; text-decoration: none">{{ $t(("message.Browse Courses")) }}</a>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="jobFunctionList">
                    <div class="jobFunction"  :class="active" v-on:click="openEvent()">
                        <div class="jobFunction-contian">
                            <span class="jobGroup mainColor jobGroupText SemiBold">
                                <a href="javascript:;" style="color: inherit; text-decoration: none">{{ $t(("message.Self-Assessment")) }}</a>
                            </span>
                            <i class="icon-add mainColor" ></i>
                        </div>
                        <VueSlideToggle :open="isOpen" tag="section" :duration="500">
                          <div class="childrenMenu">
                            <div class="mainColor pointer SemiBold" v-on:click="select('InterestAssessment','InterestAssessment')">
                                <a href="javascript:;" style="color: inherit; text-decoration: none">{{$t('message.Interest-Career Quiz')}}</a>
                            </div>
                            <div class="mainColor pointer SemiBold" v-on:click="select('selfSkillInfo','selfSkillInfo')">
                                <a href="javascript:;" style="color: inherit; text-decoration: none">{{$t('message.Skill-Career Quiz')}}</a>
                            </div>
                            <div class="mainColor pointer SemiBold" v-on:click="select('backgroundInfo','backgroundInfo')">
                                <a href="javascript:;" style="color: inherit; text-decoration: none">{{$t('message.Background-Career Quiz')}}</a>
                            </div>
                          </div>
                        </VueSlideToggle>
                    </div>
                </div>
                <div class="jobFunctionList">
                    <div class="jobFunction"  :class="active" v-on:click="select('About Us','aboutUs')">
                        <div class="jobFunction-contian">
                            <span class="jobGroup mainColor jobGroupText SemiBold">
                                <a href="javascript:;" style="color: inherit; text-decoration: none">{{ $t(("message.About Us")) }}</a>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="jobFunctionList">
                    <div class="jobFunction"  :class="active" v-on:click="select('Resources','resources')">
                        <div class="jobFunction-contian">
                            <span class="jobGroup mainColor jobGroupText SemiBold">
                                <a href="javascript:;" style="color: inherit; text-decoration: none">{{ $t(("message.Resources")) }}</a>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="jobFunctionList">
                    <div class="jobFunction"  :class="active" v-on:click="select('Privacy Policy','privacyPolicy')">
                        <div class="jobFunction-contian">
                            <span class="jobGroup mainColor jobGroupText SemiBold">
                                <a href="javascript:;" style="color: inherit; text-decoration: none">{{ $t(("message.Privacy Policy")) }}</a>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="jobFunctionList">
                    <div class="jobFunction"  :class="active" v-on:click="select('Disclaimer','disclaimer')">
                        <div class="jobFunction-contian">
                            <span class="jobGroup mainColor jobGroupText SemiBold">
                                <a href="javascript:;" style="color: inherit; text-decoration: none">{{ $t(("message.Disclaimer")) }}</a>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="jobFunctionList">
                    <div class="jobFunction"  :class="active" v-on:click="select('Feedback','feedback')">
                        <div class="jobFunction-contian">
                            <span class="jobGroup mainColor jobGroupText SemiBold">
                                <a href="javascript:;" style="color: inherit; text-decoration: none">{{ $t(("message.Feedback")) }}</a>
                            </span>
                        </div>
                    </div>
                </div>
               </div>
               <img class="bgImg2 noSelect" v-if="$store.state.innerWidth<=960" src="../images/deco-18.png" />
            </div>
        </div>
      </div>
      <img class="bgImg noSelect" v-if="$store.state.innerWidth>960" src="../images/deco-18.png" />
    </div>
  </div>
</template>
<script>
import Breadcrumbs from "@/components/Breadcrumbs";
import { VueSlideToggle } from 'vue-slide-toggle'

export default {
    name:"siteMap",
  data() {
    return {
      isOpen: false,
      active:"",
        }
    },   
  props:[
  'logGaEvent'
  ],
  components: {
    Breadcrumbs,
    VueSlideToggle
  },
  created() {},
  methods: {
  },
  mounted() {
    var that = this;
    setTimeout(function(){
      that.$store.state.mate.title = that.$i18n.t("message."+that.$route.meta.title)+' - talent.gov.hk - '+that.$i18n.t("message.Default Page Title");
    })

    this.$store.state.selectMenu = 0;
    this.select = function(name,path) {
        this.logGaEvent("userClick", "Site Map", name);
        this.$router.push({path:"/" + path, query:{lang:this.$store.state.language}});
         window.scrollTo(0, 0);
    }
    this.openEvent = function(){
        this.isOpen = !this.isOpen;
        let that =this
        setTimeout(function() {
            that.active=that.isOpen?'active':''
        });
    }
  }
};
</script>